import { ComponentTable } from '../component.constants';
import {
  GetActivitiesSections_getActivitiesSections_components_ActivitiesTableComponent_properties,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesTableComponent_properties_table,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesTableComponent_properties_table_rows,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesTableComponent_properties_table_rows_cells,
} from 'approot/activity-builder/__generated__/GetActivitiesSections';
import { Settings } from 'approot/shared/richtext/richtext.constants';
import { SuggestedAnswerFragment_suggestedAnswers } from '../suggested-answers/__generated__/SuggestedAnswerFragment';
import { JSONObject } from 'global/graphql/scalars.type';

export type TableProperties = GetActivitiesSections_getActivitiesSections_components_ActivitiesTableComponent_properties;
export type Table = GetActivitiesSections_getActivitiesSections_components_ActivitiesTableComponent_properties_table;
export type TableRow = GetActivitiesSections_getActivitiesSections_components_ActivitiesTableComponent_properties_table_rows;
export type TableCell = GetActivitiesSections_getActivitiesSections_components_ActivitiesTableComponent_properties_table_rows_cells;

export type Row = {
  cells: TableCell[];
};

export type ViewProps = Omit<ComponentTable, '__typename'>;
export type EditProps = ViewProps;
export type SettingsProps = ViewProps & { onCloseChildDrawer?: () => void };

export const TABLE_TYPENAME = 'ActivitiesTableComponent';

export const RICHTEXT_SETTINGS: Settings = {
  canChangeBlockType: true,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
  canChangeFonts: true,
  canAddLinks: true,
  canAlignText: true,
  canHighlight: true,
};

export const MAX_TABLE_COLUMNS = 6;
export const MAX_TABLE_ROWS = 10;
export const NEW_TABLE_COLUMN_WIDTH = 100;
export const MIN_TABLE_COLUMN_WIDTH = 50;

export type TableDataCell = {
  isAnswer: boolean;
  suggestedAnswer?: SuggestedAnswerFragment_suggestedAnswers;
  value: JSONObject;
};

export type TableDataRow = {
  cells: TableDataCell[];
};

export type TableData = {
  showColumnHeaders: boolean;
  showRowHeaders: boolean;
  columnWidths: number[];
  rows: TableDataRow[];
};
